// import {Tooltip, Button} from '@osui/ui';
export default function UpgradeIstioButton() {
    // TODO 暂时隐掉 istio 的升级按钮
    return (
        <>
        </>
        // <Tooltip placement="top" title={<>当前版本已为最新版<br />本，无需进行操作。</>}>
        //     <Button type="link" disabled>升级</Button>
        // </Tooltip>
    );
}
